import { FC } from "react";

import { useGuides } from "../visualGuides";
import { ListWrapper } from "../ui/layout/listPages";
import { DetailedCard } from "../components/GeneralUI/DetailedCardComponents";
import { unfulfilledConditionPage } from "../components/GeneralUI/Message/unfulfilledConditionPage";

const LIST_TITLE = "Help";
export const VisualGuides: FC = () => {
  const { startDemo, setListableDrivers } = useGuides();
  const listableDrivers = setListableDrivers();
  return listableDrivers.length ? (
    <ListWrapper title={LIST_TITLE} createPermissions="" newItemTitle="">
      <div className="grid grid-cols-1 gap-4">
        {listableDrivers.map(
          ({ driverMenuItemTitle, driverData, steps }, index) => {
            return (
              <DetailedCard
                isExtended={false}
                canSelfExtend={steps.length > 0}
                title={driverMenuItemTitle}
                onClick={() => startDemo(driverData)}
                key={index}
              >
                <ol
                  key={`${index}Description`}
                  type="i"
                  className="mt-2 cursor-default list-decimal rounded-md bg-stone-100 p-2 pl-8 text-left text-sm text-stone-900 dark:bg-black dark:text-white"
                  onClick={(e) => e.stopPropagation()}
                >
                  {steps.map((description, stepIndex) => {
                    return (
                      <li className="my-2" key={`${index} ${stepIndex}`}>
                        {description}
                      </li>
                    );
                  })}
                </ol>
              </DetailedCard>
            );
          },
        )}
      </div>
    </ListWrapper>
  ) : (
    unfulfilledConditionPage("connect the site first", "Visual Guides", "use")
  );
};
